import NavbarItem from './NavbarItem/navbarItem.vue';

export default {
    data() {
        return {
            menuItems: [],
            languages: [],
            currentLanguage: {},
            currentUrl: '',
            themes: [],
            isPrivate: payload.el == 'Private',
            allowThemes: payload.allowThemes,
            showChangePassword: payload.showChangePassword
        }
    },
    computed: {
        currentLanguageIcon(){
            return 'dist/' + this.currentLanguage.Culture + '.png'
        },
        minimalDesign() {
            return payload.minimalDesign
        }
    },
    props: [
        'container'
    ],
    mounted() {
        this.menuItems = payload.menuItems;
        this.languages = payload.languages;
        this.currentLanguage = payload.currentLocale;
        this.currentUrl = payload.currentUrl;
        this.themes = payload.themes;
        this.allowThemes = payload.allowThemes;
        // check menu item and add & remove item and put them in more item
        $(window).on('resize', () => {
            if (window.innerWidth > 768) {
                this.ckeckMenuItems();
            }
        });

        $('.js_sideToggle-sidebar').on('click', () => {
            setTimeout(() => {
                    this.ckeckMenuItems();
                },
                80);
        });
    },
    updated() {
        // check menu item and add & remove item and put them in more item
        this.$nextTick(() => this.ckeckMenuItems());
    },
    methods: {
        checkMenuMoreItem() {
            let moreItems = $(this.$el).find('.js_mainMenu .other-menu');

            if ($('.js_mainMenu .more li').length > 0) {
                moreItems.removeClass('hidden');
            } else {
                moreItems.addClass('hidden');
            }
        },
        getLastMenuItem() {
            return $(this.$el).find('.js_mainMenu > li:not(.more, .homeIcon)').last();
        },
        getFirstMenuItem() {
            return $(this.$el).find('.js_mainMenu li.more > ul > li').first();
        },
        countMenuItem() {
            return this.menuItems.length;
        },
        putItemToMainMenu(firstItem) {
            firstItem.insertBefore($(this.$el).find('.js_mainMenu li.more'));
        },
        putItemToMore(lastItem) {
            lastItem.attr('data-width', lastItem.outerWidth())
                .prependTo($(this.$el).find('.js_mainMenu .more > ul'));
        },
        putItemToSubmenu(value) {
            if ($(value).hasClass('dropdown')) {
                $(value).attr('class', 'dropdown-submenu js_hasSub');
            }
        },
        checkToOpenSubmenu() {
            let menuItem = $(this.$el).find('.js_mainMenu > li');
            let menuItemCount = menuItem.length;

            menuItem.removeClass('reverse');

            for (let i = Math.ceil(menuItemCount / 2) + 1; i <= menuItemCount; i++) {
                $(this.$el).find('.js_mainMenu > li:nth-child(' + i + ')').addClass('reverse');
            }
        },
        ckeckMenuItems() {
            let navwidth;
            let availableWidth;

            // if menu in responsive mode and change to horizontal mode
            if (window.innerWidth < 768) {
                for (let i = 0; i < this.countMenuItem(); i++) {
                    let firstItem = this.getFirstMenuItem();
                    this.putItemToMainMenu(firstItem);
                }
                // check if dropdown menu for .more is empty or not
                this.checkMenuMoreItem();
                return;
            }

            // calculate available menu width
            let moreWidth = 0;
            if ($(this.$el).find('.js_mainMenu .more').is(":visible") == true)
                moreWidth = $(this.$el).find('.js_mainMenu .more').outerWidth();

            let toggleWidth = 0;
            if ($(this.$el).find('.sidebar-toggle_container').is(":visible"))
                toggleWidth = $(this.$el).find('.sidebar-toggle_container').outerWidth();

            availableWidth = $('#nav-main-menu').outerWidth() - $(this.$el).find('.js_mainMenu .homeIcon').outerWidth() - toggleWidth - moreWidth - $(this.$el).find('.navbar-right').outerWidth() - 120;

            for (let i = 0; i < this.countMenuItem(); i++) {
                navwidth = 0;
                $('.js_mainMenu > li:not(.more, .homeIcon)').each(function () {
                    navwidth += $(this).outerWidth();
                });

                if (navwidth > availableWidth) {
                    //put item from menu to .more ul
                    let lastItem = this.getLastMenuItem();
                    this.putItemToSubmenu(lastItem);
                    this.putItemToMore(lastItem);

                } else {
                    //put item from .more ul to menu
                    let firstItem = this.getFirstMenuItem();
                    if (navwidth + firstItem.data('width') < availableWidth) {
                        this.putItemToMainMenu(firstItem);
                    }
                }
            }

            // check if dropdown menu for .more is empty or not
            this.checkMenuMoreItem();

            // check if dropdown menu open in right or left
            this.checkToOpenSubmenu();

            // if a dropdown menu removed from a nested dropdown menu
            $(this.$el).find('.js_mainMenu > li.js_hasSub').attr('class', 'dropdown');
        }
        ,togglePanel() {
            $('.js_changePasswordPanel').toggleClass('open');
        },
        closePanel() {
            $('.js_changePasswordPanel').removeClass('open');
        },
        preventPanel() {
            $('.navbar-right > li:not(.js_changePasswordPanel)').removeClass('open')
        },
    },
    components: {
        NavbarItem
    }
}
